import request from 'common/utils/axios-request';

import { GeopointApi } from './types/Geopoint';

export function geopointApiGet(): Promise<GeopointApi> {
  return request('/api/v1/settings/client/GEOPOINT_MAP_SETTINGS').then(
    ({ data }) => data.json as GeopointApi
  );
}
